import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { NextPage } from 'next';

import useAuth from '@utils/useAuth';
import { AppRoutes } from '@utils/appRoutes';

const OrderFlowStepOne: NextPage = () => {
  const router = useRouter();

  const { detectedCountryCode: countryCode } = useAuth();

  useEffect(() => {
    if (countryCode) router.push(`/${countryCode}${AppRoutes.ORDER_STEP_TWO}`);
  }, [countryCode]);

  return null;
};

export default OrderFlowStepOne;
